/**
 *
 * @page 企业中心/数据看板/管理员/巡检质量统计
 *
 **/

import dayjs from 'dayjs';
import { useReducer } from 'react';
import { useRouteMatch, useLocation } from 'react-router-dom';
import { useStoreState } from '&/utils/customHooks';
import { observer } from 'mobx-react';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import { Button, Form, Table, Space, message, Tooltip } from 'antd';
import { Select as AntSelect } from '&/components/AntdEncapsulation';
import {
    getManegers,
    getQualityList,
    getQualityDetail,
} from '@/api/personCenter/dataBoard';
import OrganizationSelect from '@/components/UserCenter/OrganizationSelect';
import BaseDrawer from '&/components/BaseDrawer';
import { DAY_OPTIONS, downloadExcel } from './constants';
import './InspectionList.scss';

function InspectionList() {
    const isAdmin = useRouteMatch({
        path: '/user-center/administrator/inspection-list',
        strict: false, // 全路径?
        sensitive: true, // 大小写?
    });

    const location = useLocation();
    const { search } = location;
    const urlParams = new URLSearchParams(search);
    const initManager = urlParams.get('manager');
    const initDays = urlParams.get('days');

    const { entId } = useStoreState('dataBoard');

    const [result, setResult] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const dftParams = {
        days: initDays !== null ? +initDays : 30,
        managerId: initManager,
        isAll: 1,
        export: 0,
    };

    if (isAdmin) dftParams.entId = entId;

    const [queryForm, setQueryForm] = useState(dftParams);

    const [didUpdate, forceUpdate] = useReducer(s => s + 1, 0);

    // 初始化调用和entId更新调用
    useEffect(() => {
        if (isAdmin) {
            setQueryForm({
                ...queryForm,
                entId,
                isAll: !entId ? 1 : 2,
            });

            setDetailParams(prev => ({
                ...prev,
                entId,
                isAll: !entId ? 1 : 2,
                managerId: initManager,
                export: 0,
            }));
        }
        forceUpdate();
    }, [entId]);

    useEffect(() => {
        queryManagerOptions(queryForm);
    }, [queryForm.entId]);

    const onParamChange = (val, key) => {
        setQueryForm(prev => ({ ...prev, [key]: val, page: 1 }));
        forceUpdate(); // 防止输入时不停触发搜索
    };

    // const handlePageChange = (page, pageNum) => {
    //     setQueryForm(prev => ({ ...prev, page, pageNum }));
    //     forceUpdate();
    // };

    const queryList = async () => {
        const PAYLOAD = { ...queryForm };
        !PAYLOAD.entId && delete PAYLOAD.entId;
        const { export: isExport } = PAYLOAD;
        try {
            !isExport && setIsLoading(true);
            const res = await getQualityList(PAYLOAD);
            if (isExport) {
                downloadExcel(res, '巡检质量统计').catch(err => {
                    if (err.code === 0) {
                        message.warn('无内容');
                    } else {
                        message.warn(err?.msg);
                    }
                });
            } else {
                const { data } = res;
                const list = (data || []).map(item => {
                    item.stageName = item['_id'].stageName;
                    return item;
                });

                setResult(list);
            }
        } finally {
            setIsLoading(false);
            isExport && setQueryForm(prev => ({ ...prev, export: 0 }));
        }
    };

    useEffect(() => {
        didUpdate > 0 && queryList();
    }, [didUpdate]);

    const dftManeger = {
        value: null,
        label: intl.get('base.all'),
    };
    const [managerOpts, setManagerOpts] = useState([dftManeger]);

    function queryManagerOptions(payload) {
        const PARAMS = {
            isAll: payload.isAll,
            roleId: 2, // 项目经理
        };

        if (payload.entId) {
            PARAMS.entId = payload.entId;
        }
        getManegers(PARAMS).then(({ data }) => {
            const opts = [dftManeger];
            for (const el of data.list) {
                opts.push({
                    value: el.userId,
                    label: el.username,
                });
            }
            setManagerOpts(opts);
        });
    }

    const [visible, setVisible] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);
    const [detailData, setDetailData] = useState([]);
    const allProject = { value: null, label: '全部' };
    const [detailParams, setDetailParams] = useState({
        projectName: allProject,
        isAll: 1,
        isQualify: 0,
        managerId: initManager,
        export: 0,
    });

    useEffect(() => {
        if (!visible) {
            initParams();
        }
    }, [visible]);

    useEffect(() => {
        visible && queryDetail();
    }, [detailParams]);

    const [detaileTitle, setDetaileTitle] = useState('');

    const [projectNameOpts, setProjectNameOpts] = useState([allProject]);

    function initParams() {
        setDetailParams(prev => ({
            ...prev,
            projectName: allProject,
            isQualify: 0,
            managerId: initManager,
            export: 0,
        }));
        setProjectNameOpts([]);
    }

    const showDetail = (isQualify, { stageName }) => {
        setVisible(true);
        setDetailParams(prev => ({
            ...prev,
            stageName,
            isQualify,
            managerId: initManager,
            export: 0,
            days: queryForm.days,
        }));
        setDetaileTitle(
            `${stageName}-巡检${
                isQualify === 2 ? '不合格' : '部分合格'
            }次数统计`
        );
    };

    function queryDetail() {
        const PARAMS = { ...detailParams };
        PARAMS.projectName = detailParams.projectName?.label;
        if (!detailParams.projectName || !detailParams.projectName.value) {
            PARAMS.projectName = '';
        }
        !PARAMS.entId && delete PARAMS.entId;
        const { export: isExport } = PARAMS;
        !isExport && setDetailLoading(true);
        getQualityDetail(PARAMS)
            .then(res => {
                if (isExport) {
                    downloadExcel(res, detaileTitle).catch(err => {
                        if (err.code === 0) {
                            message.warn('无内容');
                        } else {
                            message.warn(err?.msg);
                        }
                    });
                } else {
                    const { data } = res;
                    setDetailData(data);
                    // 根据projectId去重
                    if (projectNameOpts.length) return;
                    const result = Object.values(
                        data.reduce((acc, cur) => {
                            const { projectId } = cur;
                            acc[projectId] = {
                                value: projectId,
                                label: cur.projectName,
                            };
                            return acc;
                        }, {})
                    );
                    setProjectNameOpts([allProject].concat(result));
                }
            })
            .finally(() => {
                setDetailLoading(false);
            });
    }

    const onClose = () => {
        setVisible(false);
    };

    const { Item } = Form;

    const subColumns = [
        {
            title: intl.get('base.serialNum'),
            key: '1',
            width: 60,
            align: 'center',
            render: (_, __, idx) => {
                return idx + 1;
            },
        },
        {
            title: '项目名称',
            width: 100,
            dataIndex: 'projectName',
            align: 'center',
        },
        {
            title: '巡检意见',
            dataIndex: 'remark',
            width: 100,
            align: 'center',
            ellipsis: true,
            render(val) {
                return (
                    <Tooltip
                        title={val}
                        autoAdjustOverflow
                        placement="left"
                        overlayClassName="tooltip-container--inspection">
                        <span>{val}</span>
                    </Tooltip>
                );
            },
        },
        {
            title: '巡检时间',
            dataIndex: 'checkDate',
            align: 'center',
            width: 130,
            render: date =>
                date ? dayjs.unix(date).format('YYYY.MM.DD HH:mm') : '',
        },
        {
            title: '项目经理',
            dataIndex: 'manager',
            align: 'center',
            width: 120,
            ellipsis: true,
            render(val) {
                return (
                    <Tooltip
                        title={val}
                        autoAdjustOverflow
                        placement="left"
                        overlayClassName="tooltip-container--inspection">
                        <span>{val}</span>
                    </Tooltip>
                );
            },
        },
        {
            title: '手机号码',
            dataIndex: 'managerMobile',
            align: 'center',
            ellipsis: true,
            render(val) {
                return (
                    <Tooltip
                        title={val}
                        autoAdjustOverflow
                        placement="left"
                        overlayClassName="tooltip-container--inspection">
                        <span>{val}</span>
                    </Tooltip>
                );
            },
        },
    ];

    const onExoprtDetail = () => {
        setDetailParams(prev => ({ ...prev, export: 1 }));
    };

    const detailModalEl = (
        <BaseDrawer
            visible={visible}
            title={
                <>
                    {detaileTitle}
                    <Button
                        type="primary"
                        onClick={onExoprtDetail}
                        disabled={!detailData.length}>
                        导出表单
                    </Button>
                </>
            }
            destroyOnClose
            bodyStyle={{
                padding: '1.375rem 1.25rem',
            }}
            className="inspection-item-detail"
            onClose={onClose}>
            <Space>
                <Item label={'项目名称'}>
                    <AntSelect
                        labelInValue
                        value={detailParams.projectName}
                        onChange={projectName =>
                            setDetailParams(prev => ({
                                ...prev,
                                projectName,
                                export: 0,
                            }))
                        }
                        options={projectNameOpts}
                    />
                </Item>
                {isAdmin && (
                    <Item label={'项目经理'}>
                        <AntSelect
                            onChange={e =>
                                setDetailParams(prev => ({
                                    ...prev,
                                    managerId: e,
                                    export: 0,
                                }))
                            }
                            options={managerOpts}
                            className="manager-select"
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            value={detailParams.managerId}
                        />
                    </Item>
                )}
                <Item label={'时间区间'}>
                    <AntSelect
                        value={detailParams.days}
                        onChange={e =>
                            setDetailParams(prev => ({
                                ...prev,
                                days: e,
                                export: 0,
                            }))
                        }
                        options={DAY_OPTIONS(intl)}
                    />
                </Item>
            </Space>

            <Table
                className="normal-table"
                loading={detailLoading}
                bordered
                columns={subColumns}
                dataSource={detailData}
                scroll={{
                    y: 'calc(100vh - 12.4rem)',
                }}
                size="small"
                pagination={false}
            />
        </BaseDrawer>
    );

    const columns = [
        {
            title: intl.get('base.serialNum'),
            key: '1',
            width: 70,
            align: 'center',
            render: (_, __, idx) => {
                return (
                    idx + 1 /*  + (queryForm.page - 1) * queryForm.pageNum */
                );
            },
        },
        {
            title: '施工阶段',
            dataIndex: 'stageName',
        },
        {
            title: '合格次数',
            dataIndex: 'qualified',
        },
        {
            title: '部分合格次数',
            align: 'center',
            dataIndex: 'partQualified',
            render: (partQualified, row) => {
                return (
                    <span
                        className="native-link"
                        onClick={() => showDetail(3, row)}>
                        {partQualified}
                    </span>
                );
            },
        },
        {
            title: '不合格次数',
            align: 'center',
            dataIndex: 'notQualified',
            render: (notQualified, row) => {
                return (
                    <span
                        className="native-link"
                        onClick={() => showDetail(2, row)}>
                        {notQualified}
                    </span>
                );
            },
        },
        {
            title: '项目经理',
            align: 'center',
            dataIndex: 'manager',
        },
        {
            title: '更新时间',
            dataIndex: 'checkDate',
            align: 'center',
            render: date =>
                date ? dayjs.unix(date).format('YYYY.MM.DD HH:mm') : '',
        },
    ];

    const onExoprt = () => {
        setQueryForm(prev => ({ ...prev, export: 1 }));
        forceUpdate(); // 防止输入时不停触发搜索
    };

    const addBtn = (
        <Button type="primary" onClick={onExoprt} disabled={!result.length}>
            导出表单
        </Button>
    );

    const [page, setPage] = useState(1);

    return (
        <>
            {isAdmin && <OrganizationSelect />}
            <BasePageWrap
                title={<strong>巡检质量统计</strong>}
                className="inspection-list"
                type="card"
                headerRight={addBtn}>
                <header className="member-list-form">
                    {isAdmin && (
                        <Item label={'项目经理'}>
                            <AntSelect
                                onChange={e => onParamChange(e, 'managerId')}
                                options={managerOpts}
                                className="manager-select"
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                value={queryForm.managerId}
                            />
                        </Item>
                    )}
                    <Item label={'时间区间'}>
                        <AntSelect
                            value={queryForm.days}
                            onChange={e => onParamChange(e, 'days')}
                            options={DAY_OPTIONS(intl)}
                        />
                    </Item>
                </header>

                <Table
                    rowKey="checkDate"
                    className="normal-table"
                    loading={isLoading}
                    bordered
                    columns={columns}
                    dataSource={result}
                    size="small"
                    pagination={{
                        size: 'small',
                        current: page,
                        onChange: setPage,
                        defaultPageSize: 15,
                        total: result.length,
                        showSizeChanger: false,
                        style: { marginBottom: 0 },
                        showTotal: total => intl.get('base.total', { total }),
                    }}
                />
            </BasePageWrap>
            {detailModalEl}
        </>
    );
}

export default observer(InspectionList);
